<style>
  .ivu-modal-footer{border: none;}
  .ivu-select-multiple{height: 32px;}
  .ivu-select-selection{z-index:100;}
</style>
<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query2">
          <row :gutter="80">
            <i-col span="4">
              <form-item label="学生姓名" prop="studentName">
                <Input
                  v-model="query2.studentName"
                  clearable
                  placeholder="请输入"
                />
              </form-item>
            </i-col>
            <i-col span="4">
              <form-item label="学生身份证" prop="studentIdcard">
                <Input
                  v-model="query2.studentIdcard"
                  clearable
                  placeholder="请输入"
                />
              </form-item>
            </i-col>
            <i-col span="4">
              <form-item label="区域" prop="county">
                <Select v-model="query2.county" clearable>
                  <Option
                    v-for="item in schoolRegionlist"
                    :key="item.index"
                    :value="item.type"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="4">
              <form-item label="就读学校" prop="school">
                <Input
                  v-model="query2.school"
                  clearable
                  placeholder="请输入"
                />
              </form-item>
            </i-col>
            <i-col span="4">
              <form-item label="是否录入" prop="input">
                <Select v-model="query2.input" clearable>
                  <Option
                    v-for="item in inputlist"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="4">
               <form-item label="入学时间" prop="admissionDate">
                 <DatePicker type="daterange" split-panels placeholder="请选择日期" v-model="admissionDate" style="width: 100%;"></DatePicker>
               </form-item>
             </i-col>
           </row>
        </i-form>
      </div>
      <div class="table-data">
        <div class="bottomtable">
          <i-table
            :columns="tableHeader2"
            :border="true"
            :loading="isLoading"
            :data="tableData2"
            stripe
            height="540"
            ref="table"
          >
            <template slot-scope="{ row, index }" slot="action2">
              <Poptip
                transfer
                confirm
                title="确认删除?"
                placement="left"
                @on-ok="handleClickDetail(row, 'del')"
              >
                <span class="action">[删除]</span>
              </Poptip>
              <span class="action"  @click="handleClickDetail(row,'xiugai')">[修改]</span>
            </template>

          </i-table>
        </div>
        <div class="page">
          <page
            :total="total2"
            :current="pageNum2"
            :page-size="pageSize2"
            :page-size-opts="pagesizeopts"
            @on-change="pageChange2"
            show-total
            show-sizer
            @on-page-size-change="onpagesizechange"
          />
        </div>
      </div>

      <Modal  v-model="modal1" title="设置学生信息">
          <i-form ref="search" :model="query3">
            <row :gutter="80">
              <i-col span="12">
                <form-item label="学生姓名" prop="studentName">
                  <Input
                    v-model="query3.studentName"
                    clearable
                    placeholder="请输入"
                  />
                </form-item>
              </i-col>
              <i-col span="12">
                <form-item label="学生身份证" prop="studentIdcard">
                  <Input
                    v-model="query3.studentIdcard"
                    clearable
                    placeholder="请输入"
                  />
                </form-item>
              </i-col>
              <i-col span="12">
                <form-item label="区域" prop="county">
                  <Select v-model="query3.county" clearable>
                    <Option
                      v-for="item in schoolRegionlist"
                      :key="item.index"
                      :value="item.type"
                      :label="item.type"
                    ></Option>
                  </Select>
                </form-item>
              </i-col>
              <i-col span="12">
                <form-item label="就读学校" prop="school">
                  <Input
                    v-model="query3.school"
                    clearable
                    placeholder="请输入"
                  />
                </form-item>
              </i-col>
             </row>
          </i-form>
          <div slot="footer">
              <Button type="error" size="large" long  @click="surerevise">确认</Button>
          </div>
      </Modal>

    </div>
  </div>
</template>



<script>
import miment from "miment";
import pageHead from "../../../components/head";
import PreviewImg from "../../../components/previewImg";
import api from "../../../api/index";
const {
  selectGraduationList,
  insertNewStudentGraduation,
  updateNewStudentGraduation,
  deleteNewStudentGraduation,
  educationPermissionCheck,//查询是否教育局

} = api;

export default {
  name: "fivesixinfo",
  components: {
    pageHead
  },

  data() {
    return {
      btnList: [
        {name: "查询",type: "search"},
        {name: "重置",type: "refresh"},
        {name: "新增",type: "add"},
      ],
      iseducation:false,
      modal1:false,
      schoolTypelist:[
        {index: 0,type: "小学"},
        {index: 1,type: "初中"},
      ],
      inputlist:[
        {index: 0,type: "已录入"},
        {index: 1,type: "未录入"},
      ],
      schoolRegionlist:[
        {index: 0,type: "市直"},
        {index: 1,type: "油田"},
        {index: 2,type: "开发区"},
        {index: 3,type: "华龙区"},
        {index: 4,type: "示范区"},
      ],
      admissionDate: ['2022-01-01', miment().add(1,'DD').format()],
      query2: {
       	county: "",
       	school: "",
        studentName:'',
        studentIdcard:'',
        input:'',
        beginTime: "2022-01-01",
        endTime: miment().add(1,'DD').format()
      },
      query3: {
        id:'',
        county: "",
        school: "",
        studentName:'',
        studentIdcard:'',
      },
      isLoading: false,
      isBtbLoading: false,
      pageNum2: 1,
      pageSize2: 20,
      pagesizeopts:[20,40,60,80,100],
      total2: 0,
      title: "五升六学籍信息",
      tableHeader2: [
        {type: "selection",width:70,align: "center",},
        {title: "学生姓名",key: "studentName",width:110,},
        {title: "学生身份证",key: "studentIdcard",width:220},
        {title: "行政区域",key: "county",width:150},
        {title: "就读学校",key: "school"},
        {title: "是否录入",key: "input",width:150},
        {title: "操作",slot: "action2",width:200,},
      ],
      tableData2: [],
      selectedList: [],
      selectedListid:[],
      header: {
        token: window.sessionStorage.getItem("token"),
      },
    };
  },
  watch: {
    admissionDate(newVal, oldVal){
      this.query2.beginTime = miment(newVal[0]).format()
      this.query2.endTime = miment(newVal[1]).add(1,'DD').format()
    }
  },
  methods: {
    onpagesizechange(e){
      console.log(e)
      this.pageSize2=e
      this.pageNum2 = 1;
      this.getLandTransferList2();
    },
    handleClickDetail(item, type) {
      console.log(item, type);
      if (type == "del") {
        this.handleDelete(item.id);
      }else if(type == "xiugai"){
        this.query3={
          id:item.id,
          county: item.county,
          school: item.school,
          studentName:item.studentName,
          studentIdcard:item.studentIdcard,
        }
        this.datatype="xiugai"
        this.modal1=true;
      }
    },
    async handleDelete(id) {
      if(this.iseducation){
        if(localStorage["uid"]){
          let url=deleteNewStudentGraduation+localStorage["uid"]+"/"+id
          let res = await this.$post(url, {});
          if (res.isSucceed) {
            this.$Message.success("删除成功");
            this.getLandTransferList2();
          }
        }else{
          this.$Message.info("uid过期，请重新登录");
        }
      }else{
        this.$Message.info("您无此权限");
      }

    },
    handleSelect(selection) {
      this.selectedListid = [];
      selection.forEach((item) => {
        this.selectedListid.push(item.id);
      });
    },
    handleBtn(type){
      if (type == "add") {
       this.query3={
        id:'',
        county: "",
        school: "",
        studentName:'',
        studentIdcard:'',
       }
       this.datatype="add"
       this.modal1=true;
      }else  if (type == "search") {
        this.getLandTransferList2();
      }else  if (type == "refresh") {
        this.query2={
           county: "",
           school: "",
           studentName:'',
           studentIdcard:'',
           input:''
        }
        this.pageNum2=1
        this.getLandTransferList2();
      }
    },

    async surerevise () {
        if(!this.query3.studentName){
          this.$Message.success("请输入学生姓名");
          return ;
        }
       if(!this.query3.studentIdcard){
         this.$Message.success("请输入学生身份证");
         return ;
       }
       if(this.query3.county!==0){
         if(!this.query3.county){
           this.$Message.success("请选择区域");
           return ;
         }
       }
       if(!this.query3.school){
         this.$Message.success("请输入就读学校");
         return ;
       }
       console.log(this.query3)
       let url=''
       if(this.datatype=="add"){
         url=insertNewStudentGraduation+localStorage["uid"]
       }else if(this.datatype=="xiugai"){
         url=updateNewStudentGraduation+localStorage["uid"]
       }

       let res = await this.$post(url, {
         ...this.query3,
       });
       if (res.isSucceed) {
         this.$Message.success("保存成功");
         this.getLandTransferList2();
         this.modal1=false;
       }
    },

    cancelModal() {},
    pageChange2(val) {
      this.pageNum2 = val;
      this.getLandTransferList2();
    },

    async geteducationPermissionCheck(){
      if(localStorage["uid"]){
        let url=educationPermissionCheck+localStorage["uid"]
        let res = await this.$post(url, {});
        console.log(res)
        if (res.isSucceed&&res.code==1) {
          this.iseducation=true
        }else{
          this.iseducation=false
        }
      }else{
        this.$Message.info("uid过期，请重新登录");
      }
    },
    async getLandTransferList2() {
      this.isLoading = true;
      let url=selectGraduationList+localStorage["uid"]
      let data={
        pageNum:this.pageNum2,
        pageSize:this.pageSize2,
        ...this.query2
      }
      try {
        let res = await this.$post(url,data);
        if(res.rows&&res.rows.length>0){
          let list = res.rows.map((item) => ({
            ...item,
            input:item.input==0?'已录入':'未录入'
          }));
          console.log(list);
          this.tableData2 = list;
          this.total2 = res.total;
        }else{
          this.tableData2 = [];
          this.total2=0
        }

      } finally {
        this.isLoading = false;
      }
    },
  },

  created() {
    this.modal1=false;
    this.getLandTransferList2()
    this.geteducationPermissionCheck()
  },
  mounted() {},
};
</script>

<style  scoped lang="less">
.content {
  margin:0 20px 20px 20px;
}
.toptab{width: 100%;display: flex;display: -webkit-flex;justify-content: space-between;border-bottom: solid 1px #EEEEEE;}
.toptableft{width: 100%;display: flex;display: -webkit-flex;}
.toptableft span{width: 86px;height: 32px;text-align: center;line-height: 32px;font-size: 16px;}
.bottombtn{width:150px;text-align: center;height:32px;line-height:32px;font-size: 16px;color: #FFFFFF;border-radius: 6px;background: #0097FF;}
.activetap{background: #FF7B44;color: #FFFFFF;border-radius: 6px 6px 0 0;}
.nomaltap{background: #FFFFFF;color: #666666;border-radius: 6px 6px 0 0;border: solid 1px #EEEEEE;}
.search {width: 100%;background-color: white;border-radius: 5px;padding: 20px;margin-bottom: 20px;}

.label {width: 100px;}

.bottomtable{width: 100%;padding:20px;}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  min-height: calc(100vh - 320px);
  .page {width: 100%;display: flex;justify-content: center;}
  .success {color: #ff7b44;}
  .action {color: #5e6d94;cursor: pointer;margin-right: 10px;}
}

.statistics {padding: 10px 0;text-align: right;}

.estateTitle {color: #ff7b44;font-weight: bold;}

.estateNO {color: #ff7b44;font-weight: 400;background: #ffefe9;margin: 0 15px 10px 0;}
.topformbox{width: 100%;background: #F8F8F8;height: 80px;border-radius: 4px 4px 0px 0px;display: flex;display: -webkit-flex;align-items: center;justify-content: space-between;}
.topformbox .ivu-form{width: 100%;height: 80px;display: flex;display: -webkit-flex;align-items: center;}
.topformbox .ivu-form .ivu-form-item{margin: 0;width: 360px;}
.topformbox .ivu-form .ivu-form-item:nth-child(1){margin-left: 21px;}
.topformboxright{height: 80px;display: flex;display: -webkit-flex;align-items: center;}
.topformboxright span:nth-child(1){width: 92px;height: 28px;background: #FF7943;border-radius: 4px;text-align: center;line-height: 28px;font-size: 14px;color: #FFFFFF;margin-right: 20px;}
.topformboxright span:nth-child(2){width:120px;height: 28px;background: #F9FAFA;border: 1px solid #DEDEDE;border-radius: 4px;text-align: center;line-height: 28px;font-size: 14px;color: #4B4B4B;margin-right: 20px;}

.schoolbox{width: 100%;}


</style>
